import Select from "react-select";

const CustomerSelect = ({ customers, setFieldValue, error, isDisabled }) => {
  // Remove duplicates and prioritize the customer with a valid userLinePrice
  const options = [
    ...new Map(
      customers
        .filter((customer) => customer.customerCode) // Filter valid customers with customerCode
        .map((customer) => [
          customer.customerCode, 
          customer
        ]) // Map to Map where customerCode is the key
        .reduce((acc, [key, customer]) => {
          // For duplicate customerCodes, prioritize the customer with a userLinePrice
          if (acc.has(key)) {
            // If the customer already exists, replace it only if the userLinePrice is non-null
            if (!acc.get(key).userLinePrice && customer.userLinePrice) {
              acc.set(key, customer);
            }
          } else {
            acc.set(key, customer);
          }
          return acc;
        }, new Map())
    ).values(),
  ].map((customer) => ({
    value: customer.id,
    label: `${customer.customerCode}`,
  }));

  return (
    <div className="col-md-6">
      <label className="form-label">
        Mã khách hàng <span className="text-danger">*</span>
      </label>
      <Select
        options={options}
        placeholder="--Chọn--"
        onChange={(selectedOption) => setFieldValue("userId", selectedOption?.value)}
        isSearchable
        isDisabled={isDisabled}
      />
      {/* Display error if userId is not selected */}
      {error && <div className="text-danger mt-1">{error}</div>}
    </div>
  );
};

export default CustomerSelect;
